export const SET_HOVERED_EVENT = 'setHoveredEvent';
export const REMOVE_HOVERED_EVENT = 'removeHoveredEvent';
export const START_EVENT_EDIT = 'setEditedEvent';
export const UPDATE_EDITED_EVENT = 'updateEditedEvent';
export const STOP_EVENT_EDIT = 'stopEventEdit';
